import { publishers, brands, insights, keywords, hubs } from 'api';

import { fetchPayload, fetchList } from '@bit/knotchinc.web-react-components.utils.fetch-actions';

export const ADD_ENTITY_INSIGHTS = 'ADD_ENTITY_INSIGHTS';
export const REMOVE_ENTITY_INSIGHTS = 'REMOVE_ENTITY_INSIGHTS';

export const ADD_ENTITY_INSIGHTS_METADATA = 'ADD_ENTITY_INSIGHTS_METADATA';
export const ADDED_ENTITY_INSIGHTS_METADATA = 'ADDED_ENTITY_INSIGHTS_METADATA';

export const FETCH_ENTITY_CONTENT_INSIGHTS = 'FETCH_ENTITY_CONTENT_INSIGHTS';
export const FETCHED_ENTITY_CONTENT_INSIGHTS = 'FETCHED_ENTITY_CONTENT_INSIGHTS';

export const FETCH_ENTITY_PUBLISHERS_INSIGHTS = 'FETCH_ENTITY_PUBLISHERS_INSIGHTS';
export const FETCHED_ENTITY_PUBLISHERS_INSIGHTS = 'FETCHED_ENTITY_PUBLISHERS_INSIGHTS';

export const FETCH_ENTITY_BRANDS_INSIGHTS = 'FETCH_ENTITY_BRANDS_INSIGHTS';
export const FETCHED_ENTITY_BRANDS_INSIGHTS = 'FETCHED_ENTITY_BRANDS_INSIGHTS';

export const FETCH_ENTITY_HUBS_INSIGHTS = 'FETCH_ENTITY_HUBS_INSIGHTS';
export const FETCHED_ENTITY_HUBS_INSIGHTS = 'FETCHED_ENTITY_HUBS_INSIGHTS';

export const FETCH_ENTITY_KEYWORDS_INSIGHTS = 'FETCH_ENTITY_KEYWORDS_INSIGHTS';
export const FETCHED_ENTITY_KEYWORDS_INSIGHTS = 'FETCHED_ENTITY_KEYWORDS_INSIGHTS';

export const SET_INSIGHTS_FILTERS = 'SET_INSIGHTS_FILTERS';

/* INSIGHTS - Partnership -> Keyword Insights */
export const fetchPartnershipKeywordsInsights = (clear, entityId, partnerId, entityType) => (dispatch, getState) =>
  fetchList({
    clear,
    dispatch,
    store: getState().Insights,
    fetchingActionType: FETCH_ENTITY_KEYWORDS_INSIGHTS,
    fetchedActionType: FETCHED_ENTITY_KEYWORDS_INSIGHTS,
    apiCall:
      entityType === 'brand'
        ? (filters) => keywords.getPartnershipKeywordInsights(entityId, partnerId, filters)
        : (filters) => keywords.getPartnershipKeywordInsights(partnerId, entityId, filters),
    fetchingPayload: { entityId },
  });

/* INSIGHTS - Partnership [hubs] -> Keyword Insights */
export const fetchHubsKeywordsInsights = (clear, entityId, hubId) => (dispatch, getState) =>
  fetchList({
    clear,
    dispatch,
    store: getState().Insights,
    fetchingActionType: FETCH_ENTITY_KEYWORDS_INSIGHTS,
    fetchedActionType: FETCHED_ENTITY_KEYWORDS_INSIGHTS,
    apiCall: (filters) => keywords.getHubsKeywordInsights(entityId, hubId, filters),
    fetchingPayload: { entityId },
  });

/* INSIGHTS - All -> Add Entity */
export const addEntityInsights = (id, type) => (dispatch) =>
  fetchPayload({
    dispatch,
    fetchingActionType: ADD_ENTITY_INSIGHTS_METADATA,
    fetchedActionType: ADDED_ENTITY_INSIGHTS_METADATA,
    apiCall: type === 'brand' ? () => brands.getBrandMetadata(id) : () => publishers.getPublisherMetadata(id),
  });

/* INSIGHTS - Brand -> Hubs Insights */
export const fetchEntityHubsInsights = (clear, entityId) => (dispatch, getState) =>
  fetchList({
    clear,
    dispatch,
    fetchingActionType: FETCH_ENTITY_HUBS_INSIGHTS,
    fetchedActionType: FETCHED_ENTITY_HUBS_INSIGHTS,
    store: getState().Insights,
    apiCall: (filters) => hubs.getBrandHubs(entityId, filters),
    fetchingPayload: { entityId },
  });

/* INSIGHTS - All -> Content Insights */
export const fetchEntityContentInsights = (entityId, type) => (dispatch, getState) =>
  fetchPayload({
    dispatch,
    store: getState().Insights,
    fetchingActionType: FETCH_ENTITY_CONTENT_INSIGHTS,
    fetchedActionType: FETCHED_ENTITY_CONTENT_INSIGHTS,
    apiCall: (filters) => insights.getEntityInsights(entityId, filters, type),
    fetchingPayload: { entityId },
  });

/* INSIGHTS - Brands -> Publisher Insights */
export const fetchBrandsPublishersInsights = (clear, entityId) => (dispatch, getState) =>
  fetchList({
    clear,
    dispatch,
    store: getState().Insights,
    fetchingActionType: FETCH_ENTITY_PUBLISHERS_INSIGHTS,
    fetchedActionType: FETCHED_ENTITY_PUBLISHERS_INSIGHTS,
    apiCall: (filters) => publishers.getBrandsPublishersInsights(entityId, filters),
    fetchingPayload: { entityId },
  });

/* INSIGHTS - Brands -> Keyword Insights */
export const fetchBrandsKeywordsInsights = (clear, entityId) => (dispatch, getState) =>
  fetchList({
    clear,
    dispatch,
    store: getState().Insights,
    fetchingActionType: FETCH_ENTITY_KEYWORDS_INSIGHTS,
    fetchedActionType: FETCHED_ENTITY_KEYWORDS_INSIGHTS,
    apiCall: (filters) => keywords.getBrandsKeywordInsights(entityId, filters),
    fetchingPayload: { entityId },
  });

/* INSIGHTS - Publishers -> Brands Insights */
export const fetchPublishersBrandsInsights = (clear, entityId) => (dispatch, getState) =>
  fetchList({
    clear,
    dispatch,
    store: getState().Insights,
    fetchingActionType: FETCH_ENTITY_BRANDS_INSIGHTS,
    fetchedActionType: FETCHED_ENTITY_BRANDS_INSIGHTS,
    apiCall: (filters) => brands.getPublishersBrandsInsights(entityId, filters),
    fetchingPayload: { entityId },
  });

/* INSIGHTS - Publishers -> Keyword Insights */
export const fetchPublishersKeywordsInsights = (clear, entityId) => (dispatch, getState) =>
  fetchList({
    clear,
    dispatch,
    store: getState().Insights,
    fetchingActionType: FETCH_ENTITY_KEYWORDS_INSIGHTS,
    fetchedActionType: FETCHED_ENTITY_KEYWORDS_INSIGHTS,
    apiCall: (filters) => keywords.getPublishersKeywordInsights(entityId, filters),
    fetchingPayload: { entityId },
  });

/* INSIGHTS - Partnership -> Content Insights */
export const fetchPartnershipContentInsights = (entityId, partnerId, entityType) => (dispatch, getState) =>
  fetchPayload({
    dispatch,
    store: getState().Insights,
    fetchingActionType: FETCH_ENTITY_CONTENT_INSIGHTS,
    fetchedActionType: FETCHED_ENTITY_CONTENT_INSIGHTS,
    apiCall:
      entityType === 'brand'
        ? (filters) => insights.getPartnershipInsights(entityId, partnerId, filters)
        : (filters) => insights.getPartnershipInsights(partnerId, entityId, filters),
    fetchingPayload: { entityId },
  });

/* INSIGHTS - Partnership [hubs] -> Content Insights */
export const fetchHubsContentInsights = (entityId, hubId) => (dispatch, getState) =>
  fetchPayload({
    dispatch,
    store: getState().Insights,
    fetchingActionType: FETCH_ENTITY_CONTENT_INSIGHTS,
    fetchedActionType: FETCHED_ENTITY_CONTENT_INSIGHTS,
    apiCall: (filters) => insights.getHubsInsights(entityId, hubId, filters),
    fetchingPayload: { entityId },
  });
